// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loading_loadingContainer__3D1l6","content":"Loading_content__1GJIu","loader":"Loading_loader__RN8sm","spin":"Loading_spin__29llv"};